import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e8727e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip-title" }
const _hoisted_2 = { class: "s2-ml" }
const _hoisted_3 = { class: "tip-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "xn-footer" }

import { computed, ref } from 'vue'
import { useStore } from 'vuex'



export default /*#__PURE__*/_defineComponent({
  __name: 'tip',
  setup(__props) {

const store = useStore()
// 自定义样式title全部使用slot
const title = computed(() => (store.state.modal.data?.tip?.modal?.title || '提示'))
const width = computed(() => (+store.state.modal.data?.tip?.modal?.width || 420))
const content = computed(() => (store.state.modal.data?.tip?.modal?.content || ''))
const theme = computed(() => (store.state.modal.data?.tip?.modal?.theme || 'warning'))
const okType = computed<any>(() => (store.state.modal.data?.tip?.modal?.submitType || 'primary'))
const okDanger = computed<any>(() => (store.state.modal.data?.tip?.modal?.okDanger || false))
const submitText = computed<any>(() => (store.state.modal.data?.tip?.modal?.submitText || '确认'))
const cancelText = computed<any>(() => (store.state.modal.data?.tip?.modal?.cancelText || '取消'))

const attrs = computed(() => {
  const { data } = store.state.modal
  if (data?.tip?.modal) {
    const { title, ...rest } = data.tip.modal
    return rest
  }
  return {}
})

const loading = ref(false)
const submit = () => {
  loading.value = true
  const api = store.state.modal.data?.tip?.modal?.api
  if (api) api(close)
  else close()
}

const toCancel = () => {
  const api = store.state.modal.data?.tip?.modal?.cancelApi
  if (api) api(close)
  else close()
}

const close = () => {
  store.commit('modal/close', { uid: 'tip' })
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_xn_icon = _resolveComponent("xn-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_xn_modal = _resolveComponent("xn-modal")!

  return (_openBlock(), _createBlock(_component_xn_modal, _mergeProps(attrs.value, {
    width: width.value,
    uid: "tip",
    class: "tip-modal"
  }), {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_xn_icon, {
          icon: `alert_${theme.value}`,
          class: "icon"
        }, null, 8, ["icon"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "text",
          innerHTML: content.value
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          loading: loading.value,
          type: okType.value,
          danger: okDanger.value,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(submitText.value), 1)
          ]),
          _: 1
        }, 8, ["loading", "type", "danger"]),
        _createVNode(_component_a_button, {
          loading: loading.value,
          onClick: toCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(cancelText.value), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 16, ["width"]))
}
}

})